import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=032fc309&scoped=true"
import script from "./remarks.vue?vue&type=script&lang=js"
export * from "./remarks.vue?vue&type=script&lang=js"
import style0 from "./remarks.vue?vue&type=style&index=0&id=032fc309&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fc309",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032fc309')) {
      api.createRecord('032fc309', component.options)
    } else {
      api.reload('032fc309', component.options)
    }
    module.hot.accept("./remarks.vue?vue&type=template&id=032fc309&scoped=true", function () {
      api.rerender('032fc309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerInformation/remarks.vue"
export default component.exports